/**
 * EmailDisabledIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const EmailDisabledIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22.806 3.207a1 1 0 0 1 0 1.414l-.87.873q.063.242.064.506v12a2 2 0 0 1-2 2l-12.572-.002-3.007 3.008a1 1 0 0 1-1.414-1.414L21.392 3.207a1 1 0 0 1 1.414 0M17.84 4l-2 2H5.41l5.215 5.214-1.41 1.41L4 7.41v10.428l-1.492 1.494a2 2 0 0 1-.503-1.183L2 18V6a2 2 0 0 1 2-2zM20 7.427 9.428 17.998 20 18z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const EmailDisabledIcon = makeIcon('EmailDisabledIcon', EmailDisabledIconSvg)
